import { inject, InjectionToken } from '@angular/core';
import { Platform } from '@ionic/angular';
import { PlatformType } from '../enums';

export const PLATFORM_TOKEN: InjectionToken<PlatformProvider> = new InjectionToken<PlatformProvider>('PLATFORM_TOKEN', {
  factory: (): PlatformProvider => {
    const platform: Platform = inject(Platform);
    const isHybrid: boolean = platform.is(PlatformType.HYBRID);

    return {
      get isAndroid(): boolean {
        return isHybrid && platform.is(PlatformType.ANDROID);
      },

      get isiOS(): boolean {
        return isHybrid && platform.is(PlatformType.IOS);
      },

      get isNativeRun(): boolean {
        return isHybrid;
      },

      get isMobileWeb(): boolean {
        return platform.is(PlatformType.MOBILE_WEB);
      },

      get platformType(): PlatformType {
        if (this.isAndroid) return PlatformType.ANDROID;
        if (this.isiOS) return PlatformType.IOS;
        if (isHybrid) return PlatformType.HYBRID;
        if (platform.is(PlatformType.MOBILE_WEB)) return PlatformType.MOBILE_WEB;
        return PlatformType.WEB;
      }
    };
  }
});

export interface PlatformProvider {
  get isAndroid(): boolean;
  get isiOS(): boolean;
  get isNativeRun(): boolean;
  get isMobileWeb(): boolean;
  get platformType(): PlatformType;
}
